module.exports = __webpack_public_path__ + "static/media/work-4.65ddc2af.jpg";